import React from 'react';
import styled from 'styled-components';

const PageTitle = ({ children }) => (
  <Container>
    <Inner>
      <h1>{children}</h1>
    </Inner>
  </Container>
);

const Container = styled.div`
  background-color: red;
  width: 100%;
  padding-top: 100px;
  min-height: 200px;
  display: flex;
  align-items: center;
  h1 {
    color: floralwhite;
  }
`;

const Inner = styled.div`
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
  flex-grow: 1;
  padding: 24px;
  @media (max-width: 600px) {
    justify-content: center;
  }
`;

export default PageTitle;
